module.exports = __webpack_public_path__ + "img/3-sendi.3d0278e9.png";